import {CSSProperties, FC} from 'react';


export interface IIconVerifiedAvitoProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconVerifiedAvito: FC<IIconVerifiedAvitoProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21 21"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M11.247 1.064a.833.833 0 0 0-1.16 0L8.32 2.774 5.886 2.43a.833.833 0 0 0-.938.68l-.425 2.423-2.172 1.152a.833.833 0 0 0-.358 1.103l1.08 2.209-1.08 2.209a.833.833 0 0 0 .358 1.102l2.172 1.152.425 2.422a.833.833 0 0 0 .938.682l2.434-.345 1.768 1.71a.833.833 0 0 0 1.159 0l1.767-1.71 2.435.345a.833.833 0 0 0 .937-.681l.425-2.422 2.172-1.153a.833.833 0 0 0 .358-1.102l-1.08-2.21 1.08-2.208a.833.833 0 0 0-.358-1.103l-2.172-1.152-.425-2.422a.833.833 0 0 0-.937-.681l-2.435.344-1.767-1.71ZM14.59 8.92l-4.167 4.167a.833.833 0 0 1-1.178 0L7.16 11.003A.833.833 0 0 1 8.34 9.824l1.494 1.494 3.577-3.577a.833.833 0 1 1 1.179 1.178Z" />
        </svg>
    );
};
